// extracted by mini-css-extract-plugin
module.exports = {"day":"CalendarMonthDay_day__ECGrb","date":"CalendarMonthDay_date__qe3b1"};